var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclip2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/paperclip-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperclip-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3302 12.1499L9.86018 14.6199C8.49018 15.9899 8.49018 18.1999 9.86018 19.5699C11.2302 20.9399 13.4402 20.9399 14.8102 19.5699L18.7002 15.6799C21.4302 12.9499 21.4302 8.50992 18.7002 5.77992C15.9702 3.04992 11.5302 3.04992 8.80018 5.77992L4.56018 10.0199C2.22018 12.3599 2.22018 16.1599 4.56018 18.5099",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip2);
export default __webpack_public_path__ + "static/media/paperclip-2.fcb2573b31ebea5c44fedf22ea17853d.svg";
export { ForwardRef as ReactComponent };